import { getEnvVariable } from "../../modules/environmentalList"

export const AdminList = {
    'LAOACS': {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#00bfa5'
                    }
                }, 
                {
                    "type": "menu",
                    "title": "Invoice Dashboard",
                    "icon": "assessment",
                    "materialicon": "assessment",
                    "link": "/billingdashboard",
"reloadtab": true,
                    "key": "billingdashboard",
                    "style": {
                        'color': '#c158dc'
                    }
                },
            ],
        "myportallist":
            [
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },
                {
                    "type": "recordmenu",
                    "title": "Records",
                    "materialicon": "source",
                    "key": "Records",
                    "items": [],
                    "lskey": "submodule"
                },

                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                {
                    "type": "menu",
                    "title": "Applicants",
                    "icon": "fa fa-building",
                    "link": "/Administration/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
                {
                    "type": "menu",
                    "title": "External Contacts",
                    "key": "contacts",
                    "link": "/Administration/globalexternalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "portrait",
                    "style": {
                        'color': '#006064'
                    }
                },
            ],
            "Adminlist":
        [     
                {
                    "type": "menu",
                    "title": "Users",
                    "icon": "fa fa-users",
                    "link": "#/Administration/agencyusers",
                    "key": "AgencyUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Roles",
                    "key": "roles",
                    "link": "#/Administration/roles",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "manage_accounts",
                    "style": {
                        'color': '#004d40'
                    }
                },
                {
                    "type": "menu",
                    "title": "Groups",
                    "key": "groups",
                    "link": "#/Administration/groups",
                    "icon": "fa fa-users",
                    "materialicon": "device_hub",
                    "style": {
                        'color': '#3f51b5'
                    }
                },
                {
                    "type": "menu",
                    "title": "Districts",
                    "key": "districts",
                    "link": "#/Administration/districts",
                    "icon": "fa fa-map",
                    "materialicon": "map",
                    "style": {
                        'color': '#c158dc'
                    }
                },
                {
                    "type": "menu",
                    "title": "Parish",
                    "key": "sites",
                    "link": "#/Administration/counties",
                    "icon": "fa fa-globe",
                    "materialicon": "settings_system_daydream",
                    "style": {
                        'color': '#006064'
                    }
                },


                {
                    "type": "menu",
                    "title": "Email Groups",
                    "key": "groupemails",
                    "link": "#/Administration/groupemails",
                    "icon": "fa fa-domain",
                    "materialicon": "email",
                    "style": {
                        'color': '#0c755b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Attachment Types",
                    "key": "attachmenttypes",
                    "link": "#/Administration/attachmenttypes",
                    "icon": "fa fa-paperclip",
                    "materialicon": "attach_file",
                    "style": {
                        'color': '#b26a00'
                    }
                },
                {
                    "type": "menu",
                    "title": "Image Types",
                    "key": "imagetypes",
                    "link": "#/Administration/imagetypes",
                    "icon": "fa fa-file-image-o",
                    "materialicon": "wallpaper",
                    "style": {
                        'color': '#ffb300'
                    }
                },
                {
                    "type": "menu",
                    "title": "Invoice Cycles",
                    "key": "invoicecycles",
                    "link": "#/Administration/invoicecycles",
                    "icon": "fa fa-receipt",
                    "materialicon": "attach_money",
                    "style": {
                        'color': '#140c47'
                    }
                },
           
                // {
                //     "type": "menu",
                //     "title": "Consultants",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/consultants",
                //     "key": "consultants",
                //     "materialicon": "connect_without_contact",
                //     "style": {
                //         'color': '#cddc39'
                //     }
                // },
                {
                    "type":"menu",
                    "title": "Authorization",
                    "key": "Authorization",
                    "link": "#/Administration/authorizations",
                    "reloadtab": true,
                    "icon": "fa fa-globe",
                    "materialicon": "vpn_key",
                    "style": {
                        'color': '#c158dc'
                    }
                },   
                {
                    "type": "menu",
                    "title": "Registrations",
                    "key": "registrationrequest",
                    "link": "#/Administration/registrationrequest",
                    "icon": "fa fa-caret-square-o-right",
                    "materialicon": "how_to_vote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
                {
                    "type": "menu",
                    "title": "Invoice Management",
                    "key": "downloadallinvoices",
                    "link": "#/Administration/invoicemanagementtabs",
                    "icon": "fa fa-sync-alt",
                    "materialicon": "request_quote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
                {
                        "type": "menu",
                        "title": "Announcements",
                        "key": "announcements",
                        "link": "#/Administration/announcements",
                        "icon": "fa fa-sync-alt",
                        "materialicon": "campaign",
                        "style": {
                            'color': '#f51515ff'
                        }
                    },

            ],

        },
        'AMES': {
            "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "/Administration/applications",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },

                
                {
                    "type": "menu",
                    "title": "Applicants",
                    "icon": "fa fa-building",
                    "link": "#/Administration/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
                {
                    "type": "menu",
                    "title": "External Contacts",
                    "key": "contacts",
                    "link": "/Administration/globalexternalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#006064'
                    }
                },
                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#1a237e'
                    }
                }

            ],
        "Adminlist":
            [
                {
                    "type": "menu",
                    "title": "Users",
                    "icon": "fa fa-users",
                    "link": "#/Administration/agencyusers",
                    "key": "AgencyUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Roles",
                    "key": "roles",
                    "link": "#/Administration/roles",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "manage_accounts",
                    "style": {
                        'color': '#004d40'
                    }
                },

                {
                    "type": "menu",
                    "title": "Groups",
                    "key": "groups",
                    "link": "#/Administration/groups",
                    "icon": "fa fa-users",
                    "materialicon": "device_hub",
                    "style": {
                        'color': '#3f51b5'
                    }
                },

                {
                    "type": "menu",
                    "title": "Regions",
                    "key": "regions",
                    "link": "#/Administration/regions",
                    "icon": "fa fa-map",
                    "materialicon": "streetview",
                    "style": {
                        'color': '#61A5DC'
                    }
                },

                {
                    "type": "menu",
                    "title": "Districts",
                    "key": "districts",
                    "link": "#/Administration/districts",
                    "icon": "fa fa-map",
                    "materialicon": "map",
                    "style": {
                        'color': '#c158dc'
                    }
                },
                {
                    "type": "menu",
                    "title": "Counties",
                    "key": "sites",
                    "link": "#/Administration/counties",
                    "icon": "fa fa-globe",
                    "materialicon": "settings_system_daydream",
                    "style": {
                        'color': '#006064'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Domains",
                //     "key": "domains",
                //     "link": "#/Administration/domains",
                //     "icon": "fa fa-domain",
                //     "materialicon": "domain",
                //     "style": {
                //         'color': '#a98274'
                //     }
                // },

                {
                    "type": "menu",
                    "title": "Email Groups",
                    "key": "groupemails",
                    "link": "#/Administration/groupemails",
                    "icon": "fa fa-domain",
                    "materialicon": "email",
                    "style": {
                        'color': '#0c755b'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Applicants",
                //     "icon": "fa fa-building",
                //     "link": "#/Administration/companies",
                //     "key": "companies",
                //     "materialicon": "apartment",
                //     "style": {
                //         'color': '#ea156d'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Consultants",
                    "icon": "fa fa-building",
                    "link": "/Administration/consultants",
                    "key": "consultants",
                    "materialicon": "connect_without_contact",
                    "style": {
                        'color': '#cddc39'
                    }
                },
                {
                    "type": "menu",
                    "title": "Registrations",
                    "key": "registrationrequest",
                    "link": "#/Administration/registrationrequest",
                    "icon": "fa fa-caret-square-o-right",
                    "materialicon": "how_to_vote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
            ],

    },
    'EPS': {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "#/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },
                {
                    "type": "menu",
                    "title": "System Statistics",
                    "icon": "fa fa-pie-chart",
                    "materialicon": "poll",
                    "link": "#/systemstatistics",
                    "key": "SystemStatistics",
                    "style": {
                        'color': '#00bfa5'
                    }
                },
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Administration/applications",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },

                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                {
                    "type": "menu",
                    "title": "Companies/Applicants",
                    "icon": "fa fa-building",
                    "link": "#/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
            ],
        "Adminlist":
            [
                {
                    "type": "menu",
                    "title": "Users",
                    "icon": "fa fa-users",
                    "link": "#/Administration/agencyusers",
                    "key": "AgencyUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Counties",
                    "key": "sites",
                    "link": "#/Administration/counties",
                    "icon": "fa fa-globe",
                    "materialicon": "settings_system_daydream",
                    "style": {
                        'color': '#006064'
                    }
                },
                {
                    "type": "menu",
                    "title": "Roles",
                    "key": "roles",
                    "link": "#/Administration/roles",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "manage_accounts",
                    "style": {
                        'color': '#004d40'
                    }
                },
                {
                    "type": "menu",
                    "title": "Groups",
                    "key": "groups",
                    "link": "#/Administration/groups",
                    "icon": "fa fa-users",
                    "materialicon": "device_hub",
                    "style": {
                        'color': '#3f51b5'
                    }
                },

                {
                    "type": "menu",
                    "title": "Regions",
                    "key": "regions",
                    "link": "#/Administration/regions",
                    "icon": "fa fa-map",
                    "materialicon": "streetview",
                    "style": {
                        'color': '#61A5DC'
                    }
                },

                {
                    "type": "menu",
                    "title": "Districts",
                    "key": "districts",
                    "link": "#/Administration/districts",
                    "icon": "fa fa-map",
                    "materialicon": "map",
                    "style": {
                        'color': '#c158dc'
                    }
                },
                {
                    "type": "menu",
                    "title": "Domains",
                    "key": "domains",
                    "link": "#/Administration/domains",
                    "icon": "fa fa-domain",
                    "materialicon": "domain",
                    "style": {
                        'color': '#a98274'
                    }
                },
                {
                    "type": "menu",
                    "title": "Layers",
                    "key": "layers",
                    "link": "#/Administration/layers",
                    "icon": "fa fa-domain",
                    "materialicon": "layers",
                    "style": {
                        'color': '#c85a54'
                    }
                },

                {
                    "type": "menu",
                    "title": "Group Emails",
                    "key": "groupemails",
                    "link": "#/Administration/groupemails",
                    "icon": "fa fa-domain",
                    "materialicon": "settings_overscan",
                    "style": {
                        'color': '#d14d1d'
                    }
                },
                {
                    "type": "menu",
                    "title": "Configurations",
                    "key": "settings",
                    "link": "#/Administration/settings",
                    "icon": "fa fa-domain",
                    "materialicon": "settings_suggest",
                    "style": {
                        'color': '#5ddef4'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Sidebar Rules",
                //     "key": "settings",
                //     "link": "#/Administration/sidebarbr",
                //     "icon": "fa fa-domain",
                //     "materialicon": "ballot",
                //     "style": {
                //         'color': '#aeea00'
                //     }
                // },
                // {
                //     "type": "menu",
                //     "title": "Project Messages",
                //     "key": "projectmessages",
                //     "link": "/Administration/projectmessages",
                //     "icon": "fa fa-domain",
                //     "materialicon": "message",
                //     "style": {
                //         'color': '#940786'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Registrations",
                    "key": "registrationrequest",
                    "link": "#/Administration/registrationrequest",
                    "icon": "fa fa-caret-square-o-right",
                    "materialicon": "how_to_vote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
            ],

    },
    'KEPT': {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "#/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#d50000'
                    }
                },
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Records/RECYCLERS",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "search",
                    "materialicon": "search",
                    "link": "/search",
"reloadtab": true,
                    "key": "Search",
                    "style": {
                        'color': '#61A5DC'
                    }
                },

                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                {
                    "type": "menu",
                    "title": "Companies/Applicants",
                    "icon": "fa fa-building",
                    "link": "#/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
            ],
        "Adminlist":
            [
                {
                    "type": "menu",
                    "title": "Users",
                    "icon": "fa fa-users",
                    "link": "#/Administration/agencyusers",
                    "key": "AgencyUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Roles",
                    "key": "roles",
                    "link": "#/Administration/roles",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "manage_accounts",
                    "style": {
                        'color': '#004d40'
                    }
                },

                {
                    "type": "menu",
                    "title": "Groups",
                    "key": "groups",
                    "link": "#/Administration/groups",
                    "icon": "fa fa-users",
                    "materialicon": "device_hub",
                    "style": {
                        'color': '#3f51b5'
                    }
                },


                // {
                //     "type": "menu",
                //     "title": "Regions",
                //     "key": "regions",
                //     "link": "#/Administration/regions",
                //     "icon": "fa fa-map",
                //     "materialicon": "streetview",
                //     "style": {
                //         'color': '#61A5DC'
                //     }
                // },

                {
                    "type": "menu",
                    "title": "Districts",
                    "key": "districts",
                    "link": "#/Administration/districts",
                    "icon": "fa fa-map",
                    "materialicon": "map",
                    "style": {
                        'color': '#c158dc'
                    }
                },
                {
                    "type": "menu",
                    "title": "Counties",
                    "key": "sites",
                    "link": "#/Administration/counties",
                    "icon": "fa fa-globe",
                    "materialicon": "settings_system_daydream",
                    "style": {
                        'color': '#006064'
                    }
                },
                {
                    "type": "menu",
                    "title": "Email Groups",
                    "key": "groupemails",
                    "link": "#/Administration/groupemails",
                    "icon": "fa fa-domain",
                    "materialicon": "email",
                    "style": {
                        'color': '#0c755b'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Project Messages",
                //     "key": "projectmessages",
                //     "link": "/Administration/projectmessages",
                //     "icon": "fa fa-domain",
                //     "materialicon": "message",
                //     "style": {
                //         'color': '#940786'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Registrations",
                    "key": "registrationrequest",
                    "link": "#/Administration/registrationrequest",
                    "icon": "fa fa-caret-square-o-right",
                    "materialicon": "how_to_vote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
            ],
    },
}

